import React, {useState} from "react";
import {useSelector} from "react-redux";
import {flowSelector} from "../../../../../redux/slices/flowSlice";
import SvgSelector from "../../../../../components/SvgSelector/SvgSelector";
import MuiTooltip from "../../../../../components/UiKit/MuiTooltip/MuiTooltip";
import ConfirmPopup from "../../../../../components/UiKit/Popups/ConfirmPopup/ConfirmPopup";
import SupportPopup from "../../../../../components/UiKit/Popups/SupportPopup/SupportPopup";
import FlowTableGeoTooltip from "../../../../../components/UiKit/FlowTableGeoTooltip/FlowTableGeoTooltip";
import FlowTableAppTooltip from "../../../../../components/UiKit/ToolTips/FlowTableAppFieldTooltip/FlowTableAppTooltip";
import {useTranslation} from "react-i18next";
import StatusContent from "../../GetFlowStatusContent/GetFlowStatusContent";
import {globalDataSelector} from "../../../../../redux/slices/globalDataSlice";
import {authSelector} from "../../../../../redux/slices/authSlice";
import {getUniqueApplications} from "../../../../../utils/helpers/getUniqueApplications";
import s from "../../flows.module.scss";
import {getLanguage} from "../../../../../storage/switchLanguage";
import {subscriptionSelector} from "../../../../../redux/slices/subscriptionSlice";
import {
    OWNER_OR_TEAM_LEAD,
    ownerAndTeamLeadList,
    TEAM_LEAD,
    teamsHighLevelAccess
} from "../../../../../utils/vars/staticVariables";
import {user_role, user_token_email} from "../../../../../storage/user";

const ExpiredTd = ({
                       settings,
                       redirector,
                       domain,
                       id,
                       notes,
                       onDuplicateFlowHandler,
                       user_email
                   }) => {

    const [activeCreateFlowPopup, setActiveCreateFlowPopup] = useState(false);
    const [activeFlowCreateLimitPopup, setActiveFlowCreateLimitPopup] =
        useState(false);

    const {geoList} = useSelector(globalDataSelector);
    const {flowsList, duplicateFlowPending} = useSelector(flowSelector);
    const {isPartner} = useSelector(authSelector);
    const {fetchSubscriptionsPending, freeDomainsCount} = useSelector(subscriptionSelector);

    const {t} = useTranslation();

    const domain_name = domain?.address

    const {geo = [], status = ""} = settings || {};

    const uniqueApplications = getUniqueApplications(redirector)

    return (
        <tr>
            <td className={s.noteTd}>
                <SupportPopup
                    icon={<SvgSelector id="popup-duplicate-icon"/>}
                    active={activeFlowCreateLimitPopup}
                    setActive={setActiveFlowCreateLimitPopup}
                    action={() => setActiveFlowCreateLimitPopup(false)}
                    title={t("duplicate_flow_title")}
                    description={t("duplicate_limit_message")}
                />
                <ConfirmPopup
                    icon={<SvgSelector id="popup-duplicate-icon"/>}
                    active={activeCreateFlowPopup}
                    setActive={setActiveCreateFlowPopup}
                    action={() => onDuplicateFlowHandler(id, domain_name, flowsList, setActiveFlowCreateLimitPopup)}
                    confirmBtnText={t("continue")}
                    title={t("duplicate_flow_title")}
                    description={
                        isPartner
                            ? `${t("duplicate_flow")} ${domain_name} ${t('notif_lowercase_flow')}?`
                            : getLanguage() === 'en'
                                ? `If you duplicate the flow, a ${freeDomainsCount > 0 ? '$0' : '$6'} fee will be deducted for the domain`
                                : `${t("duplicate_popup_content")} ${freeDomainsCount > 0 ? '$0' : '$6'} ${t('for_domain')}`
                    }
                    subDescription={t('expiring_domain_popup_warning')}
                />
                {/*<ConfirmPopup*/}
                {/*    icon={<SvgSelector id="popup-duplicate-icon"/>}*/}
                {/*    active={activeCreateFlowPopup}*/}
                {/*    setActive={setActiveCreateFlowPopup}*/}
                {/*    action={() => onDuplicateFlowHandler(id, domain_name, flowsList, setActiveFlowCreateLimitPopup)}*/}
                {/*    confirmBtnText={t("continue")}*/}
                {/*    title={t("duplicate_flow_title")}*/}
                {/*    description={*/}
                {/*        isPartner*/}
                {/*            ? `${t("duplicate_flow")} ${domain_name} ${t('notif_lowercase_flow')}?`*/}
                {/*            : t("duplicate_popup_content")*/}
                {/*    }*/}
                {/*    subDescription={t('expiring_domain_popup_warning')}*/}
                {/*/>*/}

                <div className={s.editNoteField}>
                    <div
                        className={s.noteTextBtn}
                    >
                        <div className={s.noteText}>{notes}</div>
                        <MuiTooltip title={notes}></MuiTooltip>
                    </div>
                </div>

            </td>
            <td
                className={s.domainTd}
            >
                <div className={s.domainTdContent} style={{color: '#D02533'}}>
                    <span className={s.domainName}>{domain_name}</span>
                </div>

            </td>
            <td
                style={{position: "relative"}}
                className={`${geo?.length > 0 ? s.geoTd : s.mocked}`}
            >
                <div className={s.tdContentContainer}>
                    <FlowTableGeoTooltip geos={geo} geosList={geoList}>
                        <div className={s.iterativeContentWrapper}>
                            {geo.map(({id, code}) => {
                                const foundFlag = geoList.find((item) => item.id === id)?.flag;

                                return (
                                    <span className={s.value} key={id}>
                    <span
                        className={s.iconWrapper}
                        style={{
                            backgroundImage: foundFlag
                                ? `url(${foundFlag})`
                                : "none",
                        }}
                    ></span>
                    <span>{code}</span>
                  </span>
                                );
                            })}
                        </div>
                    </FlowTableGeoTooltip>
                </div>
            </td>
            <td className={s.statusTd}>
                <div className={s.statusIndicator}>
                    <StatusContent status={status}/>
                </div>
            </td>
            <td
                className={`${uniqueApplications?.length > 0 ? s.applicationTd : s.mocked}`}
            >
                <div className={s.tdContentContainer}>
                    <FlowTableAppTooltip uniqueApplications={uniqueApplications}>
                        <div className={s.applicationContentWrapper}>
                            {uniqueApplications.map(({name, icon}, index) => (
                                <span className={s.appValue} key={index}>
                  <span
                      className={s.iconWrapper}
                      style={{
                          backgroundImage: icon ? `url(${icon})` : "none",
                      }}
                  ></span>
                  <span>{name}</span>
                </span>
                            ))}
                        </div>
                    </FlowTableAppTooltip>
                </div>
            </td>
            {
                (teamsHighLevelAccess.includes(user_role) || user_role === TEAM_LEAD) && <td>{user_email}</td>
            }
            <td className={s.actionsTd}>
                {
                    (user_role === OWNER_OR_TEAM_LEAD && user_email === user_token_email) || user_role !== OWNER_OR_TEAM_LEAD ? (
                        <div className={s.actionsWrapper}>
                            <div className={s.actionsContainer}>
                                <div className={s.actions}>
                                    <button
                                        className={`${s.manageTableFillBtn} ${s.linksBtn}`}
                                        onClick={() => {
                                            setActiveCreateFlowPopup(true);
                                        }}
                                        disabled={!settings || duplicateFlowPending || fetchSubscriptionsPending}
                                    >
                                        <MuiTooltip title={duplicateFlowPending
                                            ? t("duplicating")
                                            : !settings ? t('set_whitepage') : t("duplicate_option")}>
                                            <SvgSelector id="duplicate"/>
                                        </MuiTooltip>
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) : null

                }
                {/*{*/}
                {/*    !ownerAndTeamLeadList.includes(user_role) && <div className={s.actionsWrapper}>*/}
                {/*        <div className={s.actionsContainer}>*/}
                {/*            <div className={s.actions}>*/}
                {/*                <button*/}
                {/*                    className={`${s.manageTableFillBtn} ${s.linksBtn}`}*/}
                {/*                    onClick={() => {*/}
                {/*                        setActiveCreateFlowPopup(true);*/}
                {/*                    }}*/}
                {/*                    disabled={!settings || duplicateFlowPending || fetchSubscriptionsPending}*/}
                {/*                >*/}
                {/*                    <MuiTooltip title={duplicateFlowPending*/}
                {/*                        ? t("duplicating")*/}
                {/*                        : !settings ? t('set_whitepage') : t("duplicate_option")}>*/}
                {/*                        <SvgSelector id="duplicate"/>*/}
                {/*                    </MuiTooltip>*/}
                {/*                </button>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*}*/}
            </td>
        </tr>
    );
};

export default ExpiredTd;
